<div *ngIf="formattedValue">
    <!-- {{ params.value &nbsp; | currency:currencyCode:'symbol' }} -->
    {{ numericValue &nbsp; }}
</div>
<div *ngIf="!formattedValue && params.colDef.field == 'casePrice'">
    {{ params.value}}
</div>